import { render, staticRenderFns } from "./DiscountPlanList.vue?vue&type=template&id=c35f8bcc&scoped=true&"
import script from "./DiscountPlanList.vue?vue&type=script&lang=js&"
export * from "./DiscountPlanList.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPlanList.vue?vue&type=style&index=0&id=c35f8bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35f8bcc",
  null
  
)

export default component.exports